export class ErrorDto {
    codigoError: number;
    mensajeError: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/error-dto.ts